import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
`;

export default Container;
